import { AlertCircle, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface FormErrorProps {
  message: string | null | undefined;
  onDismiss?: () => void;
  className?: string;
}

export default function FormError({ message, onDismiss, className }: FormErrorProps) {
  const { t } = useTranslation();

  if (!message) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      className={cn(
        'flex items-start gap-2 rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive',
        className,
      )}
    >
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="flex-1">{message}</span>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 rounded-full p-0.5 hover:bg-destructive/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-destructive/50 transition-colors"
          aria-label={t('common.dismissAlert')}
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
